// Enums de pagamento moram em src/constants/payment.ts (compartilhados com o billing
// e com os componentes de components/molecules/payment). Re-exportados aqui para não
// quebrar os imports existentes deste domínio.
export {
    PaymentType, paymentTypeLabels,
    PaymentMethod, paymentMethodLabels,
    PaymentSource, paymentSourceLabels,
    SettlementType,
    AssetType, assetTypeLabels,
} from '../../../../constants/payment';
export type { AssetDationItem } from '../../../../constants/payment';

export const TitleDebtStatus = {
    OPEN: 'OPEN',
    PARTIALLY_PAID: 'PARTIALLY_PAID',
    PAID: 'PAID',
    SUPERSEDED: 'SUPERSEDED',
    CANCELLED: 'CANCELLED',
} as const satisfies Record<string, string>;
export type TitleDebtStatus = typeof TitleDebtStatus[keyof typeof TitleDebtStatus];

// BankAccount (enum hardcoded) removido — contas de recebimento agora vêm de
// GET /billing/receiving-bank-accounts via <ReceivingBankAccountSelect> (AF-3321).

export const MovementType = {
    TOTAL_PAYMENT: 'TOTAL_PAYMENT',
    PARTIAL_PAYMENT: 'PARTIAL_PAYMENT',
    RENEGOTIATION: 'RENEGOTIATION',
    REVERSAL: 'REVERSAL',
} as const satisfies Record<string, string>;
export type MovementType = typeof MovementType[keyof typeof MovementType];

export const ReversalReason = {
    PAGAMENTO_DUPLICADO: 'Pagamento duplicado',
    VALOR_INCORRETO: 'Valor incorreto',
    OPERACAO_CANCELADA: 'Operação cancelada',
    ERRO_SISTEMA: 'Erro de sistema',
} as const satisfies Record<string, string>;
export type ReversalReason = typeof ReversalReason[keyof typeof ReversalReason];

export const statusColors: Record<string, 'blue' | 'green' | 'red' | 'orange' | 'gray' | 'yellow' | 'purple'> = {
    OPEN: 'yellow',
    PAID: 'green',
    PARTIALLY_PAID: 'orange',
    SUPERSEDED: 'gray',
    CANCELLED: 'red',
};

export const statusLabels: Record<string, string> = {
    OPEN: 'Em aberto',
    PARTIALLY_PAID: 'Parcial',
    PAID: 'Pago',
    SUPERSEDED: 'Renegociado',
    CANCELLED: 'Cancelado',
};

export const movementTypeLabels: Record<string, string> = {
    TOTAL_PAYMENT: 'Pagamento Total',
    PARTIAL_PAYMENT: 'Pagamento Parcial',
    RENEGOTIATION: 'Renegociação',
    REVERSAL: 'Estorno',
};

export const settlementTypeLabels: Record<number, string> = {
    1: 'Total',
    2: 'Parcial',
    3: 'Em Atraso',
    4: 'Antecipado',
};
